import PropTypes from 'prop-types';
import React from 'react'
import { connect } from 'react-redux';

// Components
import {
	About,
	Activity, 
	EmailFrequency,
	Interests,
	Settings,
	Subscription
} from './components';



class Body extends React.Component {
    static propTypes = {
		isSessionUser: PropTypes.bool.isRequired,
		addUpdateField: PropTypes.func.isRequired,
		editing_fields: PropTypes.bool.isRequired,
		user: PropTypes.object.isRequired
	};

    static contextTypes = {
		store: PropTypes.object
	};

    render() {

		let { fetching, activity, interests } = this.props.profile,
			userInterests = this.props.isSessionUser && this.props.sessionsAllowed ? this.props.userInterests : interests;
		
		return (
			<div className="row no-gutter">

				<div className="row flex-row pbot20">
					<div className="col-sm-8">

						<About {...this.props.user} editing_fields={this.props.editing_fields} addUpdateField={this.props.addUpdateField} isSessionUser={this.props.isSessionUser} />

						<Interests interests={this.props.allInterests} userInterests={userInterests} isSessionUser={this.props.isSessionUser} />

					</div>
					<div className="col-sm-4 pleft15">

						<Activity sessionsAllowed={this.props.sessionsAllowed} activity={activity} fetching={fetching} isSessionUser={this.props.isSessionUser} />

					</div>
	            </div>

	            <div className="clearfix" />

	            { !!this.props.isSessionUser &&
					<div className="row flex-row" id="profileSettings">

						<div className="col-sm-6">
							<Settings user={this.props.user} />
						</div>

						<div className="col-sm-6">
							<EmailFrequency {...this.props.user} />
						</div>

		            </div>
		        }

	            <div className="clearfix" />

	            { !!this.props.isSessionUser &&
	            	<Subscription />
	            }

            </div>
		)
	}
}

const mapStateToProps = state => ({
    profile: state.profile,
    allInterests: state.interests.all,
    sessionsAllowed: state.session.sessionsAllowed,
    userInterests: state.session.interests,
});

export default connect(
    mapStateToProps
)(Body);




// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/index.jsx